import React, { useEffect } from "react";

/* Clouds
============================================================================= */

const Clouds = ({ className = "clouds" }) => {
	return (
		<svg
			className="absolute top-0 z-0"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 1964.22 466.42"
		>
			<defs>
				<style>{`.cls-1{ fill: #fff; mix-blend-mode: lighten; opacity: 0.5; }.cls-2{fill:#fff; opacity: 0.6; }`}</style>
			</defs>
			<g class="cls-1">
				<g id="Layer_2" data-name="Layer 2">
					<g id="background">
						<path
							class="cls-2"
							d="M760.18,91.91A852.67,852.67,0,0,1,567,117.79l478.2,26.86L922.9,176.6A1568.17,1568.17,0,0,0,1336.61,135L939.09,122c78.85-22.24,157.77-44.51,235.29-72.45,26.85-9.68,55.13-21.3,72.55-46.75A6864.79,6864.79,0,0,0,517.4,20.67L543.53,0a712.38,712.38,0,0,0-218,35.76c26.42,5.31,51.39,10.32,78.23,11.83q44,2.49,87.87,6.43,86.64,7.77,172.74,21.18,24.58,3.83,49.11,8.12C726,85.51,747.89,94.93,760.18,91.91Z"
						/>
						<path
							class="cls-2"
							d="M1165.05,15.1c-141.16,74.57-297.65,109.69-452,101.44L872.89,77.26A4078.83,4078.83,0,0,1,434,28l70.59-16.71L488.84,24.69c.23-.2,22.67,8.6,25.7,8.87,8.89.78,15.53-2.1,23.85-4.08,19.74-4.71,43-.2,63.1.31q68.43,1.71,136.91,1.72,136.35,0,272.72-6.68Q1088.12,21,1165.05,15.1Z"
						/>
						<path
							class="cls-2"
							d="M1156,140.81l-119.55-4a90.13,90.13,0,0,0,48.89,8.63,204.66,204.66,0,0,1-79.79,21.85,308,308,0,0,0,65.47-3.72,435.8,435.8,0,0,0,42.9-9.22C1126.2,151,1143.65,140.51,1156,140.81Z"
						/>
						<path
							class="cls-2"
							d="M981.5,64.47,861.42,90.29c99.44-7.7,197.9-24.61,296.2-41.51A1394.19,1394.19,0,0,0,923.06,38.72c-42.31,1.75-84.51,5.42-126.8,7.55-21.09,1.06-42.21,1.75-63.33,1.62-12.51-.08-41.85-6.94-51.3,2.06,36,9.15,77,9.6,114.1,12.16Q855.1,66.21,914.65,66,948.09,65.93,981.5,64.47Z"
						/>
						<path
							class="cls-2"
							d="M1410.31,225.19a53.15,53.15,0,0,1,22.61-28.55,1957.4,1957.4,0,0,0-468.07-38.27l120.71-15.55L1066,148c54.53-16.87,115.48,11.42,169.92-5.75,17.3-5.45,32.85-15.22,48.52-24.37,16.69-9.74,33.84-18.92,52.19-25,42.28-14,88.08-10.64,132.47-7.14L1751.74,108l-152,16.59a2545.33,2545.33,0,0,1,283.85,69.1,1265.72,1265.72,0,0,0-269.67,16l90.85,14c-31.59,10-60.64,23.54-94.15,20.48-43.13-3.93-86.24-8.17-129.36-12.26C1475.26,231.34,1410.31,226.17,1410.31,225.19Z"
						/>
						<path
							class="cls-2"
							d="M1315.87,117.86l4.32,6.26a203.15,203.15,0,0,1-123.43,30.78c32.12,12,67.07,13.54,101.35,14.91L1528.82,179l-109.15,41.38a1837.9,1837.9,0,0,0,220.72,8.42,517.41,517.41,0,0,0-87.56-21.9c74.29-26.86,155-28.65,233.93-30.15L1517.91,128c10.14,1.91,28.09-5.5,38.36-7.51,11.13-2.18,28.63-2.4,38.1-8.38-14.58-7.42-36.43-8.73-52.67-11.11a520.35,520.35,0,0,0-164.65,2.28A507.73,507.73,0,0,0,1315.87,117.86Z"
						/>
						<path
							class="cls-2"
							d="M776,456.81c-6.32-5.83-19.72-10.93-37.06-14.12,252.06-15.57,510.35-21.94,767.45-18.92l-197.92-7.7,32.12,2.57c-89.41-8.34-189.33,5.65-278.59-2.84-28.37-2.7-53.87-7.53-79.56-12.05-27.37-4.82-55.49-9.36-85.57-12.36-69.33-6.92-144.42-5.27-217.21-3.54l-463.47,11,249.19,8.2C308.27,415.75,152.79,427.17,0,441.24c147.75-2.14,296.26.51,442.15,7.89l-149,6.95c51.8,5,99.43,11.64,154.36,10.13q106.09-2.93,212.11-6.07C669.55,459.86,776,457.3,776,456.81Z"
						/>
						<path
							class="cls-2"
							d="M930.88,403.73l-7.07,3.1c59.72,11.43,131.85,16.85,202.37,15.22-52.66,5.95-110,6.69-166.17,7.37L581.72,434l179,20.46c-120.21,3.58-241.13,5-361.89,4.17,46.68-4.87,94.78-8.49,143.55-10.83-121.8-13.29-254-14.18-383.54-14.92l440.81-24.12c-16.63.94-46.06-2.72-62.89-3.72-18.25-1.08-47-1.19-62.48-4.14,23.91-3.68,59.73-4.32,86.36-5.5,30-1.32,60.24-2.16,90.53-2.51,60-.7,120.27.52,179.43,3.64C864.46,398.28,898,400.69,930.88,403.73Z"
						/>
						<path
							class="cls-2"
							d="M1085.52,154.14c-7.24,2.41-14.09,6.36-21.64,7.34-8.48,1.11-16.85-1.66-25.1-3.73-19.72-4.94-40.26-6-60.66-6.58-113.13-3.42-226.47,5.18-339.54,13.77l206.71,4.49c19.33.42,38.74.85,57.74,4.11,20.4,3.51,40.21,10.27,60.88,11.92a127,127,0,0,0,68.93-14.29c6.75-3.57,23.23-1,31.21-1.55q16.71-1.19,33.36-3.13c19-2.22,38.34-5.29,57-8.75C1132.18,154.1,1107.94,146.71,1085.52,154.14Z"
						/>
						<path
							class="cls-2"
							d="M776.15,165.43,911,171.72c21.34,1,42.8,2,64.25,1a324.46,324.46,0,0,0,70.58-11c-6.61,1.83-21.41.15-28.67-.39-11.57-.84-22.94-2.17-34.58-2.84-22.46-1.28-45.12-1.54-67.76-1.14C868.42,158.18,822.22,161.8,776.15,165.43Z"
						/>
						<path
							class="cls-2"
							d="M1526.46,309c7.1,4.37,13.8,11.57,21.19,13.36,8.31,2,16.51-3,24.59-6.79,19.32-9,39.43-10.86,59.41-12,110.82-6.22,221.82,9.43,332.57,25.06l-202.47,8.17c-18.93.76-37.94,1.54-56.55,7.48-20,6.38-39.38,18.69-59.63,21.69-23.1,3.42-46.83-5.72-67.51-26-6.61-6.49-22.76-1.79-30.57-2.82q-16.37-2.14-32.68-5.69A497.21,497.21,0,0,1,1459,315.49C1480.76,308.87,1504.5,295.43,1526.46,309Z"
						/>
						<path
							class="cls-2"
							d="M1829.47,329.5l-132,11.42c-20.91,1.81-41.92,3.62-62.93,1.81a187.5,187.5,0,0,1-69.13-20c6.47,3.32,21,.26,28.08-.71,11.33-1.54,22.47-3.95,33.87-5.16a478.54,478.54,0,0,1,66.36-2.09C1739.1,316.3,1784.35,322.88,1829.47,329.5Z"
						/>
						<path
							class="cls-2"
							d="M1087.59,362.35l73.44,8.34L916.8,390c189.67,7.73,380,8.69,569.86,2.88-67.05-9.2-135.05-15.66-203.42-19.32q77.34-1.56,154.24-7.64c-10.48.84-25.14-2.23-35.65-3.23-8-.76-15.62-2-23.44-3.19-20.2-3.14-42.25-2.73-63-3.19q-72.51-1.64-145,1.24Q1128.9,359.23,1087.59,362.35Z"
						/>
						<path
							class="cls-2"
							d="M1336.9,362.66c-62.22-2.13-124.63-2-186.82.45,21.05,8.07,46.75,9.56,71.39,9.39s49.49-1.77,73.74.95c-97.46,2-195.14,4.09-291.74,12.5,64.42,8.92,131.26,6.55,197.1,4.14l-86.07-2a1094.05,1094.05,0,0,1,239,.6,777.76,777.76,0,0,0-140.11-10.81c45.4-7,91.61-11.88,138.15-14.6"
						/>
						<path
							class="cls-2"
							d="M770.25,346.2c5-7.17,15.24-13,27.61-15.73,17.88,8.58,43.5,9.53,66.23,6.66s43.86-9.05,65.84-13.54c41.09-8.38,84.83-10.77,128.06-13.09l-6.4-6c45.89-1,91.41-8.59,131.54-21.88a1943.94,1943.94,0,0,0-270.74-6.35c24.65-7.7,52.45-11.88,80.28-12.07-105.88-4.92-213.26-9.8-317.87,1.82-28.11,3.12-55.82,7.42-83.5,11.71L369.13,312.14l87.76,3.58L411.84,325.9c9.75.86,17.66,6.25,17.7,12l113.84,7.38-11.44,2c36-.17,72.06,4,108.36,3.88C683.71,351.06,727.13,349.38,770.25,346.2Z"
						/>
						<path
							class="cls-2"
							d="M910,271.11,873.34,284a2204.46,2204.46,0,0,1,267.26,8.35l-305.85,5.95L1034,304.64Q881.79,320,728.07,328.87l48.26,1.18c-21.58,8.15-48.67,8.72-74.23,8.74-71.52.07-143-2.1-214.08-6.5l86.25-14.07-83.21-3c13.79-2.24,29-5.8,40.05-11.26-1.81-.14-4-1.27-5.84-1.48,2.21-6.52,56.43-11.37,67.6-13q37.51-5.4,75.59-9.27c50.73-5.17,102-8.3,153.41-9.37Q865.91,270,910,271.11Z"
						/>
					</g>
				</g>
			</g>
		</svg>
	);
};

/* Export
============================================================================= */

export default Clouds;
